module.exports = __webpack_public_path__ + "images/bannerFR-7a43525fa6b063222fefaae3380e1622.jpg";